import { Heading, Box, Text, Flex } from "@radix-ui/themes";

export default function WelcomeIndex() {
  return (
    <Flex
      align="center"
      justify="center"
      style={{ minHeight: "100vh" }}
    >
      <Box style={{ textAlign: "center" }}>
        <Heading size="8" as="h1">
          Welcome to Formbot
        </Heading>
        <Text as="p" size="4" style={{ marginTop: "var(--space-4)", color: "var(--gray-11)" }}>
          Your Inertia.js + React + TypeScript + Tailwind CSS + Radix UI app is ready!
        </Text>
      </Box>
    </Flex>
  )
}
